module.exports = __webpack_public_path__ + "static/media/007-behance-black.28072b2a.svg";